module.exports = __webpack_public_path__ + "static/media/nithin.2950f064.jpg";